import commonZhHK from './common_zh-HK'

const rtZhHK = {
  rt: {
    ...commonZhHK,
  }
}

export default rtZhHK